(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-grid-to-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(carouselId) {
      var root = document.getElementById(carouselId);
      var track = document.getElementById('track-' + carouselId);
      var dotsContainer = document.getElementById('dots-' + carouselId);
      var arrowsContainer = document.getElementById('arrows-' + carouselId);
      var progressContainer = document.getElementById('progress-' + carouselId);
      var progressThumb = document.getElementById('progress-thumb-' + carouselId);
      if (!track || !dotsContainer) return;

      var enableDesktopCarousel = root && root.dataset.enableDesktopCarousel === 'true';

      var slides = Array.from(track.children);
      if (slides.length === 0) return;

      var current = 0;
      var dots = [];
      var prevBtn = arrowsContainer ? arrowsContainer.querySelector('[data-arrow="prev"]') : null;
      var nextBtn = arrowsContainer ? arrowsContainer.querySelector('[data-arrow="next"]') : null;

      function isMobile() {
        return window.innerWidth < 768;
      }

      function carouselActive() {
        return isMobile() || enableDesktopCarousel;
      }

      function getStep() {
        var slide = slides[0];
        var rect = slide.getBoundingClientRect();
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return rect.width + gap;
      }

      function getWrapperWidth() {
        return track.parentElement.offsetWidth;
      }

      function getMaxTranslate() {
        return Math.max(track.scrollWidth - getWrapperWidth(), 0);
      }

      function buildDots() {
        dotsContainer.innerHTML = '';
        dots = [];
        slides.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.className = 'dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          btn.addEventListener('click', function () {
            goTo(i);
          });
          dotsContainer.appendChild(btn);
          dots.push(btn);
        });
      }

      function updateDots() {
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      function updateProgress(translate) {
        if (!progressThumb) return;
        var wrapperWidth = getWrapperWidth();
        var trackWidth = track.scrollWidth;
        if (trackWidth <= wrapperWidth) {
          progressThumb.style.width = '100%';
          progressThumb.style.left = '0%';
          if (progressContainer) progressContainer.hidden = true;
          return;
        }
        if (progressContainer) progressContainer.hidden = false;
        var widthPct = Math.max(15, (wrapperWidth / trackWidth) * 100);
        var maxTranslate = getMaxTranslate();
        var progressPct = maxTranslate > 0 ? translate / maxTranslate : 0;
        var leftPct = progressPct * (100 - widthPct);
        progressThumb.style.width = widthPct + '%';
        progressThumb.style.left = leftPct + '%';
      }

      function updateArrows(translate) {
        var maxTranslate = getMaxTranslate();
        if (prevBtn) prevBtn.disabled = translate <= 0.5;
        if (nextBtn) nextBtn.disabled = translate >= maxTranslate - 0.5;
      }

      function goTo(index) {
        current = Math.max(0, Math.min(index, slides.length - 1));
        if (!carouselActive()) {
          updateArrows(0);
          return;
        }
        var step = getStep();
        var translate = Math.min(current * step, getMaxTranslate());
        track.style.transform = 'translateX(-' + translate + 'px)';
        updateDots();
        updateProgress(translate);
        updateArrows(translate);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      var startX = 0;
      track.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        function (e) {
          if (!carouselActive()) return;
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            goTo(diff > 0 ? current + 1 : current - 1);
          }
        },
        { passive: true }
      );

      var wasActive = carouselActive();
      window.addEventListener('resize', function () {
        var activeNow = carouselActive();
        if (activeNow !== wasActive) {
          wasActive = activeNow;
          if (!activeNow) {
            track.style.transform = '';
            updateArrows(0);
          } else {
            goTo(current);
          }
        } else if (activeNow) {
          goTo(current);
        }
      });

      buildDots();
      if (carouselActive()) {
        goTo(0);
      } else {
        updateArrows(0);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-carousel-id]').forEach(function (el) {
        initCarousel(el.dataset.carouselId);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-image-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('branch-carousel')) {
    class BranchCarousel extends HTMLElement {
      #viewport = null;
      #slides = [];
      #dotsWrap = null;
      #dots = [];
      #index = 0;
      #timer = null;
      #observer = null;
      #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      connectedCallback() {
        this.#viewport = this.querySelector('[data-carousel-viewport]');
        this.#slides = Array.from(this.querySelectorAll('.branch-carousel-block__slide'));
        this.#dotsWrap = this.querySelector('[data-carousel-dots]');

        if (!this.#viewport || this.#slides.length < 2) return;

        this.#buildDots();
        this.#bindControls();
        this.#observeActiveSlide();
        this.#bindHoverPause();
        this.#startAutoplay();
      }

      disconnectedCallback() {
        this.#stopAutoplay();
        this.#observer?.disconnect();
      }

      #buildDots() {
        this.#slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'branch-carousel-block__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dot.setAttribute('aria-label', `Go to photo ${i + 1}`);
          dot.addEventListener('click', () => this.#goTo(i));
          this.#dotsWrap.append(dot);
          this.#dots.push(dot);
        });
      }

      #bindControls() {
        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.#goTo(this.#index - 1));
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.#goTo(this.#index + 1));

        this.#viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.#goTo(this.#index + 1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.#goTo(this.#index - 1);
          }
        });
      }

      #bindHoverPause() {
        this.addEventListener('pointerenter', () => this.#stopAutoplay());
        this.addEventListener('pointerleave', () => this.#startAutoplay());
        this.addEventListener('focusin', () => this.#stopAutoplay());
        this.addEventListener('focusout', () => this.#startAutoplay());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.#stopAutoplay();
          } else {
            this.#startAutoplay();
          }
        });
      }

      #observeActiveSlide() {
        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                const i = this.#slides.indexOf(entry.target);
                if (i !== -1) this.#setActive(i);
              }
            }
          },
          { root: this.#viewport, threshold: 0.6 }
        );
        this.#slides.forEach((slide) => this.#observer.observe(slide));
      }

      #setActive(index) {
        this.#index = index;
        this.#dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      }

      #goTo(index) {
        const total = this.#slides.length;
        const nextIndex = (index + total) % total;
        this.#slides[nextIndex].scrollIntoView({
          behavior: this.#reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }

      #startAutoplay() {
        if (this.#reducedMotion.matches) return;
        if (this.dataset.autoplay === 'false') return;
        this.#stopAutoplay();
        const delay = Number(this.dataset.autoplayDelay) || 4000;
        this.#timer = window.setInterval(() => this.#goTo(this.#index + 1), delay);
      }

      #stopAutoplay() {
        if (this.#timer) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }
    }

    customElements.define('branch-carousel', BranchCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dynamic-form"] && !Shopify.designMode) return;
  try {
    class DynamicForm extends HTMLElement {
    #form = null;
    #status = null;
    #submitButton = null;
    #controller = null;

    connectedCallback() {
      this.#form = this.querySelector('.dynamic-form__form');
      this.#status = this.querySelector('.dynamic-form__status');
      this.#submitButton = this.querySelector('.dynamic-form__submit');
      this.#form?.addEventListener('submit', this.#handleSubmit.bind(this));
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    /** @param {SubmitEvent} event */
    async #handleSubmit(event) {
      event.preventDefault();
      this.#clearFieldErrors();
      this.#hideStatus();

      // Honeypot: if a bot filled the hidden field, fake a success silently.
      const honeypot = this.#form.elements.namedItem('website');
      if (this.dataset.honeypot === 'true' && honeypot?.value) {
        this.#showStatus('success');
        this.#form.reset();
        return;
      }

      const validation = this.#validate();
      if (!validation.valid) {
        this.#applyFieldErrors(validation.errors);
        validation.errors[0]?.element?.focus();
        return;
      }

      const payload = this.#buildPayload();
      this.#setLoading(true);

      this.#controller?.abort();
      this.#controller = new AbortController();

      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: this.#controller.signal,
        });

        if (!response.ok) throw new Error(`Request failed with ${response.status}`);

        this.#showStatus('success');
        this.#resetForm();

        if (this.dataset.redirect) {
          window.setTimeout(() => {
            window.location.href = this.dataset.redirect;
          }, 1200);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.#showStatus('error');
        }
      } finally {
        this.#setLoading(false);
      }
    }

    /* @returns {valid: boolean, errors: Array<{id: string, message: string, element: HTMLElement}>} */
    #validate() {
      const errors = [];

      if (typeof this.#form.checkValidity === 'function' && !this.#form.checkValidity()) {
        for (const element of this.#form.elements) {
          if (element.willValidate && !element.checkValidity()) {
            const field = element.closest('[data-form-field]');
            errors.push({
              id: field?.id,
              message: element.validationMessage,
              element,
            });
          }
        }
      }

      for (const upload of this.querySelectorAll('dynamic-form-upload')) {
        const isRequired = upload.dataset.required === 'true';
        if (isRequired && !upload.hasFiles()) {
          errors.push({ id: upload.id, message: 'Please add a file.', element: upload });
        }
        if (upload.hasErrors()) {
          errors.push({ id: upload.id, message: 'Remove the invalid file(s) first.', element: upload });
        }
      }

      return { valid: errors.length === 0, errors };
    }

    /** @param {Array<{id: string, message: string, element: HTMLElement}>} errors */
    #applyFieldErrors(errors) {
      for (const error of errors) {
        const errorEl = document.getElementById(`${error.id}-error`);
        const field = error.element.closest('[data-form-field]') || error.element;
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
        field?.classList.add('form-field--invalid');
      }
    }

    #clearFieldErrors() {
      for (const errorEl of this.querySelectorAll('.form-field__error')) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      for (const field of this.querySelectorAll('.form-field--invalid')) {
        field.classList.remove('form-field--invalid');
      }
    }

    #buildPayload() {
      const fields = {};

      for (const element of this.#form.elements) {
        if (!element.name || element.name === 'website' || element.type === 'file') continue;
        if (element.type === 'submit' || element.type === 'button') continue;

        if (element.type === 'checkbox') {
          fields[element.name] = element.checked;
        } else if (element.type === 'radio') {
          if (element.checked) fields[element.name] = element.value;
        } else {
          fields[element.name] = element.value;
        }
      }

      const attachments = [];
      for (const upload of this.querySelectorAll('dynamic-form-upload')) {
        for (const file of upload.getFiles()) {
          attachments.push({ name: file.name, content: file.content, contentType: file.type });
        }
      }

      const toList = (this.dataset.to || '')
        .split(',')
        .map((email) => email.trim())
        .filter(Boolean);
      const ccList = (this.dataset.cc || '')
        .split(',')
        .map((email) => email.trim())
        .filter(Boolean);

      return {
        formName: this.dataset.formName,
        to: toList,
        cc: ccList,
        subject: this.dataset.subject,
        fields,
        attachments,
      };
    }

    #resetForm() {
      this.#form.reset();
      for (const upload of this.querySelectorAll('dynamic-form-upload')) {
        upload.reset();
      }
    }

    #setLoading(isLoading) {
      if (!this.#submitButton) return;
      this.#submitButton.disabled = isLoading;
      const spinner = this.#submitButton.querySelector('.dynamic-form__spinner');
      if (spinner) spinner.hidden = !isLoading;
    }

    #showStatus(kind) {
      if (!this.#status) return;
      const message =
        kind === 'success'
          ? this.dataset.successMessage || 'Thanks, your message has been sent.'
          : this.dataset.errorMessage || 'Something went wrong. Please try again.';

      this.#status.textContent = message;
      this.#status.hidden = false;
      this.#status.classList.remove('dynamic-form__status--success', 'dynamic-form__status--error');
      this.#status.classList.add(`dynamic-form__status--${kind}`);
    }

    #hideStatus() {
      if (!this.#status) return;
      this.#status.hidden = true;
      this.#status.classList.remove('dynamic-form__status--success', 'dynamic-form__status--error');
    }
  }

  if (!customElements.get('dynamic-form')) {
    customElements.define('dynamic-form', DynamicForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["form-field-upload"] && !Shopify.designMode) return;
  try {
    class DynamicFormUpload extends HTMLElement {
    #files = [];
    #input = null;
    #dropzone = null;
    #list = null;
    #errorTarget = null;

    connectedCallback() {
      this.#input = this.querySelector('.upload-field__input');
      this.#dropzone = this.querySelector('.upload-field__dropzone');
      this.#list = this.querySelector('[data-upload-list]');
      this.#errorTarget = document.getElementById(this.dataset.errorTarget);

      this.#input?.addEventListener('change', this.#handleChange.bind(this));
      this.#dropzone?.addEventListener('dragover', this.#handleDragOver.bind(this));
      this.#dropzone?.addEventListener('dragleave', this.#handleDragLeave.bind(this));
      this.#dropzone?.addEventListener('drop', this.#handleDrop.bind(this));
    }

    disconnectedCallback() {
      this.#files = [];
    }

    /** @returns {Array<{name: string, size: number, type: string, content: string}>} */
    getFiles() {
      return this.#files
        .filter((file) => !file.error)
        .map((file) => ({
          name: file.name,
          size: file.size,
          type: file.type,
          content: file.content,
        }));
    }

    hasFiles() {
      return this.#files.some((file) => !file.error);
    }

    hasErrors() {
      return this.#files.some((file) => file.error);
    }

    reset() {
      this.#files = [];
      if (this.#input) this.#input.value = '';
      this.#renderList();
      this.#setError('');
    }

    #handleDragOver(event) {
      event.preventDefault();
      this.classList.add('upload-field--dragover');
    }

    #handleDragLeave(event) {
      event.preventDefault();
      this.classList.remove('upload-field--dragover');
    }

    #handleDrop(event) {
      event.preventDefault();
      this.classList.remove('upload-field--dragover');
      this.#processFileList(event.dataTransfer?.files);
    }

    #handleChange(event) {
      this.#processFileList(event.target.files);
    }

    /** @param {FileList | null} fileList */
    async #processFileList(fileList) {
      if (!fileList || fileList.length === 0) return;

      const maxFiles = Number(this.dataset.maxFiles) || 1;
      const maxSizeBytes = (Number(this.dataset.maxSizeMb) || 5) * 1024 * 1024;
      const acceptList = (this.dataset.accept || '')
        .split(',')
        .map((ext) => ext.trim().toLowerCase())
        .filter(Boolean);

      const validFileCount = this.#files.filter((file) => !file.error).length;
      const incoming = Array.from(fileList).slice(0, Math.max(maxFiles - validFileCount, 0));

      if (incoming.length === 0) {
        this.#setError(`You can only add up to ${maxFiles} file${maxFiles === 1 ? '' : 's'}.`);
        if (this.#input) this.#input.value = '';
        return;
      }

      for (const file of incoming) {
        const record = { name: file.name, size: file.size, type: file.type, content: '', error: '' };
        const extension = `.${file.name.split('.').pop().toLowerCase()}`;

        if (acceptList.length > 0 && !acceptList.includes(extension)) {
          record.error = `${file.name}: file type not accepted.`;
        } else if (file.size > maxSizeBytes) {
          record.error = `${file.name}: exceeds ${this.dataset.maxSizeMb}MB limit.`;
        }

        this.#files.push(record);
        this.#renderList();

        if (!record.error) {
          try {
            record.content = await this.#readAsBase64(file);
          } catch (error) {
            record.error = `${file.name}: could not be read.`;
          }
          this.#renderList();
        }
      }

      if (this.#input) this.#input.value = '';
      this.#setError(this.hasErrors() ? 'Remove the highlighted file(s) to continue.' : '');
      this.dispatchEvent(new CustomEvent('dynamic-form:upload-change', { bubbles: true }));
    }

    /** @param {File} file @returns {Promise<string>} base64 content without the data: prefix */
    #readAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    }

    #renderList() {
      if (!this.#list) return;
      this.#list.innerHTML = '';

      this.#files.forEach((file, index) => {
        const item = document.createElement('li');
        item.className = `upload-field__item${file.error ? ' upload-field__item--error' : ''}`;

        const meta = document.createElement('span');
        meta.className = 'upload-field__item-meta';
        meta.textContent = file.error || `${file.name} (${(file.size / 1024).toFixed(0)}KB)`;

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'upload-field__item-remove';
        remove.setAttribute('aria-label', `Remove ${file.name}`);
        remove.textContent = '\u00d7';
        remove.addEventListener('click', () => {
          this.#files.splice(index, 1);
          this.#renderList();
          this.#setError(this.hasErrors() ? 'Remove the highlighted file(s) to continue.' : '');
          this.dispatchEvent(new CustomEvent('dynamic-form:upload-change', { bubbles: true }));
        });

        item.append(meta, remove);
        this.#list.append(item);
      });
    }

    #setError(message) {
      if (!this.#errorTarget) return;
      this.#errorTarget.textContent = message;
      this.#errorTarget.hidden = !message;
    }
  }

  if (!customElements.get('dynamic-form-upload')) {
    customElements.define('dynamic-form-upload', DynamicFormUpload);
  }
  } catch(e) { console.error(e); }
})();

})();
